import styled from "styled-components";
import { secondaryColor } from "../../../config";

export const BackToAdminWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 150px;
  height: 40px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border: none;
  background-size: 200% 200%;
  background-color: #383838;

  background-position: left;
  cursor: pointer;
  border-radius: 8px;
  transition: all 3s;

  &:hover {
    box-shadow: 0px 0px 20px #7c7c7c;
    background-position: right;
  }
`;
export const ProfileView = styled.div`
  .footer-sidebar {
    display: flex;
    align-items: center;
    height: 50px;
  }
  .NameFooter {
    font-weight: 700 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px !important;
    color: ${secondaryColor} !important;
  }
  .EmailFooter {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000 !important;
    font-weight: 500 !important;
    font-size: 12px !important;
  }
`;

export const MenuView = styled.div`
  .custom-dropdown-menu {
    width: 250px;
  }

  .profile-header {
    display: flex;
    align-items: center;
    padding: 16px;
  }

  .profile-info {
    margin-inline-start: 16px;
  }

  .profile-info h4 {
    margin: 0;
    font-size: 16px;
  }

  .profile-info p {
    margin: 0;
    color: #888;
  }

  .toggle-icon {
    float: inline-end;
  }

  .language-icon {
    float: inline-end;
  }

  .ant-menu-item {
    display: flex;
    justify-content: space-between;
  }

  .ant-menu-item-danger {
    text-align: center;
  }
  .fw-semibold {
    font-weight: 500;
  }
`;

export const SearchDesign = styled.div`
  .cus-search .ant-input-group-addon {
    background-color: #f4f4f4 !important;
    border: 0;
  }

  .cus-search .ant-input-lg {
    background-color: #f4f4f4 !important;
    border: 0;
  }

  .cus-search .ant-input-lg::placeholder {
    color: #333;
  }

  .cus-search .ant-input-lg:focus {
    box-shadow: none;
  }

  .min-w-250px {
    min-width: 270px;
  }

  @media (max-width: 767px) {
    .ant-space-compact.cus-search {
      display: none !important;
    }
  }
`;
